import SubsidiesWidget from './components/widgets/Subsidies.vue';

Statamic.booting(() => {
  Statamic.$components.register('SubsidiesWidget', SubsidiesWidget);
});
